import { Sprite, Text, type Texture } from 'pixi.js';
import { BrassButton, COLOURS, displayStyle, uiStyle, type BrassButtonKind } from '../board/index';

/** Display type (Lilita One): titles and numbers. */
export function display(text: string, size: number, fill: number = COLOURS.gold): Text {
  return new Text({ text, style: displayStyle(size, fill) });
}

/** Body type (Fredoka), wrapped to `width` when given. */
export function body(
  text: string,
  size: number,
  o: { width?: number; align?: 'left' | 'center'; fill?: number; weight?: '500' | '600' | '700' } = {},
): Text {
  return new Text({
    text,
    style: {
      ...uiStyle(size, o.fill ?? COLOURS.cream, o.weight ?? '600'),
      align: o.align ?? 'center',
      wordWrap: o.width !== undefined,
      wordWrapWidth: o.width ?? 0,
      lineHeight: Math.round(size * 1.3),
    },
  });
}

/** A sprite sized to fit `size` on its long side (null texture: empty). */
export function fitSprite(texture: Texture | null, size: number): Sprite {
  const s = new Sprite(texture ?? undefined);
  if (texture) s.scale.set(size / Math.max(texture.width, texture.height));
  return s;
}

/** A brass button named for browser tests (`button:<label>`). */
export function button(label: string, kind: BrassButtonKind, onTap: () => void, size?: number): BrassButton {
  const b = new BrassButton({ label, kind, onTap, size });
  b.label = `button:${label}`;
  return b;
}
